import DataTable from './DataTable';

interface ISummaryTable {
  data: { label: string; value: string }[];
  className?: string;
  valueWidth?: string;
}

const SummaryTable = (props: ISummaryTable) => {
  return (
    <DataTable
      className={props.className || 'table-borderless'}
      columns={[
        {
          render: (row) => <b>{row.label}</b>,
          name: 'label',
          className: 'px-0',
        },
        {
          selector: 'value',
          name: 'value',
          width: props.valueWidth || '70%',
        },
      ]}
      data={props.data}
      keyField='label'
      header={null}
    />
  );
};

export default SummaryTable;
